// extracted by mini-css-extract-plugin
module.exports = {"styledButtonGroup":"HeziYprU","secondary":"MVCks__e","wrapper":"ycLxqd6c","active":"pIEYlIaI"};